module.exports = __webpack_public_path__ + "static/media/w (20).cd8a0a3a.jpg";